import { call, put, takeLatest } from 'redux-saga/effects';
import {Api} from '../api';
import {IssueReport} from '../api/types';
import {enqueueErrorSnackbar} from '../action/snackbarCommands';
import {getI18n} from 'react-i18next';
import Logger from '../common/logger';
import Command from '../action/command';
import Events from '../action/event';
import { FetchIssueReportsPayload } from '../action/issueReportsCommands';

export const onFetchIssueReports = function*(includeArchived = false) {
    try {
        const issueReports: IssueReport[] = yield call(Api.getIssueReports, includeArchived);

        yield put(Events.IssueReport.issueReportsFetched({ issueReports }));
    } catch (e) {
        Logger('Saga').error(e);
        yield put(Events.IssueReport.issueReportsFetchFailed());
        yield put(enqueueErrorSnackbar({ message: getI18n().t('snackbar.error.fetch_issueReports') }));
    }
};

// takeLatest, not take + fork: the list and the detail pages fetch with
// different `includeArchived`, and with every fetch forked the slower response
// won — the list could keep a detail page's archived reports, with the fetch
// status already saying "loaded". The latest request is the one that counts.
export function* fetchIssueReportsFlow() {
    yield takeLatest(
        Command.IssueReport.fetchIssueReports.toString(),
        function* (action: { type: string, payload?: FetchIssueReportsPayload }) {
            yield call(onFetchIssueReports, action.payload?.includeArchived ?? false);
        },
    );
}
